import * as Sentry from '@sentry/react';

import { SENTRY_DSN } from 'constants/api';
import { INTEL_ADMIN_IGNORE_ERRORS } from 'constants/sentry-ignored';

const ENVIRONMENT_TYPE = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
};

function canTrackErrors() {
  return process.env.NODE_ENV !== ENVIRONMENT_TYPE.DEVELOPMENT;
}

export function initSentry() {
  if (canTrackErrors()) {
    const envName =
      process.env.REACT_APP_ENV === ENVIRONMENT_TYPE.STAGING
        ? ENVIRONMENT_TYPE.STAGING
        : process.env.NODE_ENV;

    Sentry.init({
      dsn: SENTRY_DSN,
      denyUrls: [],
      ignoreErrors: [...INTEL_ADMIN_IGNORE_ERRORS],
      release: `${envName}:${process.env.REACT_APP_SENTRY_RELEASE}`,
      environment: envName,
      integrations: [],
      tracesSampleRate: 0,
    });

    if (process.env.REACT_APP_ENV === ENVIRONMENT_TYPE.STAGING) {
      Sentry.configureScope(scope => {
        scope.setTag('sub-domain', window.location.hostname.split('.')[0].split('-')[0]);
      });
    }
  }
}

export function sentryWarningMessage({
  activityNodeData,
  condition = '',
  message = '',
  errorLevel = '',
}) {
  if (activityNodeData) {
    Sentry.configureScope(scope => {
      Sentry.setTags({
        nodeType: `${activityNodeData ? activityNodeData.node_type : ''}`,
        sheetName: `${
          activityNodeData ? activityNodeData.worksheet.learnosity_activity_ref : ''
        }`,
        conditionBreached: condition,
      });

      Sentry.captureMessage(message, errorLevel);
    });
  }
}

export function sentryErrorMessage(errorMessage, sentryTags) {
  Sentry.configureScope(scope => {
    Sentry.captureException(errorMessage, { tags: sentryTags });
  });
}
